export default {
    data() {
        return {

        }
    },
    methods: {
        resetarScrollBarMultiselect() {
            let el = document.querySelectorAll('.multiselect__content-wrapper')
            
            el.forEach((e) => {
              e.style.display = 'block'
              e.scrollTop = 0
              e.style.display = 'none'
            })
        }
    }
}